export enum PreviewDataType {
	SYS = 'sys',
	NUMBER = 'NUMBER',
	TEXT = 'TEXT'
}
